import React from 'react';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import CallToActionIcon from '@mui/icons-material/CallToAction';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import CategoryIcon from '@mui/icons-material/Category';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import Groups3Icon from '@mui/icons-material/Groups3';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LogoutIcon from '@mui/icons-material/Logout';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import PaidIcon from '@mui/icons-material/Paid';
import PersonIcon from '@mui/icons-material/Person';
import PolicyIcon from '@mui/icons-material/Policy';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import SettingsIcon from '@mui/icons-material/Settings';
import SummarizeIcon from '@mui/icons-material/Summarize';
import DiscountIcon from '@mui/icons-material/Discount';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ViewListIcon from '@mui/icons-material/ViewList';
import PaymentsIcon from '@mui/icons-material/Payments';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import TopicIcon from '@mui/icons-material/Topic';
import SnippetFolderIcon from '@mui/icons-material/SnippetFolder';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import DomainAddIcon from '@mui/icons-material/DomainAdd';
import BusinessIcon from '@mui/icons-material/Business';
import TuneIcon from '@mui/icons-material/Tune';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import DescriptionIcon from '@mui/icons-material/Description';
import ScheduleIcon from '@mui/icons-material/Schedule';
import VerifiedIcon from '@mui/icons-material/Verified';
import { locations } from '../../routes/locations';
import * as permissions from '../../utils/permissions';
import { MenuItems } from './Sidebar/types';

interface GetMenuItemsProps {
  handleLogout: () => void;
}

export const getMenuItems = ({ handleLogout }: GetMenuItemsProps): MenuItems => [
  [
    {
      title: 'Dashboard',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <DashboardIcon />,
      path: locations.dashboard(),
    },

    {
      title: 'Ratbi+',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <DomainAddIcon />,
      permissionProps: { items: [permissions.Company.list, permissions.RatibiEmployee.list], checkType: 'some' },
      children: [
        {
          title: 'Companies',
          permissionProps: { items: [permissions.Company.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <BusinessIcon />,
          path: locations.b2bThriftPlanList(),
          pathRegexp: new RegExp(`^${locations.b2bThriftPlanList()}(/\\d+|/upload-document)?$`),
        },
        {
          title: 'CSV Template',
          // permissionProps: { items: [permissions.Company.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <DocumentScannerIcon />,
          path: locations.csvTemplates(),
          pathRegexp: new RegExp(`^${locations.csvTemplates()}(/.*)?$`),
        },
        {
          title: 'Document Types',
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <DescriptionIcon />,
          path: locations.documentTypes(),
          pathRegexp: new RegExp(`^${locations.documentTypes()}(/.*)?$`),
        },
        {
          title: 'Analytics Cron',
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <ScheduleIcon />,
          path: locations.analyticsCron(),
          pathRegexp: new RegExp(`^${locations.analyticsCron()}(/.*)?$`),
        },
      ],
    },
    {
      title: 'Ledger',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <ReceiptLongIcon />,
      children: [
        {
          title: 'B2C',
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <PersonIcon />,
          path: locations.ledgerB2c(),
          pathRegexp: new RegExp(`^${locations.ledgerB2c()}$`),
        },
        {
          title: 'B2B',
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <BusinessIcon />,
          path: locations.ledgerB2b(),
          pathRegexp: new RegExp(`^${locations.ledgerB2b()}$`),
        },
      ],
    },
    {
      title: 'Users',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <FolderSharedIcon />,
      permissionProps: { items: permissions.ReadUserManagement, checkType: 'some' },
      children: [
        {
          title: 'Users',
          permissionProps: { items: [permissions.User.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <PersonIcon />,
          path: locations.userList(),
          pathRegexp: new RegExp(`^${locations.userList()}(/\\d+)?$`),
        },
        {
          title: 'Early Users',
          permissionProps: { items: [permissions.Anonymous.listEarlySignupUsers] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <DirectionsRunIcon />,
          path: locations.earlySignupUserList(),
          pathRegexp: new RegExp(`^${locations.earlySignupUserList()}(/\\d+)?$`),
        },
        {
          title: 'User Groups',
          permissionProps: { items: [permissions.UserGroup.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <Groups3Icon />,
          path: locations.userGroupList(),
        },
        {
          title: 'Gifts',
          permissionProps: { items: [permissions.UserGift.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <CardGiftcardIcon />,
          path: locations.userGiftList(),
        },
        {
          title: 'Deletion Requests',
          permissionProps: { items: [permissions.AccountDeletion.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <PersonRemoveIcon />,
          path: locations.accountDeletionList(),
        },
      ],
    },
    {
      title: 'Employees',
      permissionProps: { items: [permissions.Employee.list] },
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <SupportAgentIcon />,
      path: locations.employeeList(),
      pathRegexp: new RegExp(`^${locations.employeeList()}(/\\d+)?$`),
    },
    {
      title: 'Portfolios',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <SnippetFolderIcon />,
      permissionProps: { items: permissions.ReadPortfolioManagement, checkType: 'some' },
      children: [
        {
          title: 'Currency',
          permissionProps: { items: [permissions.Currency.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <PaidIcon />,
          path: locations.currencyList(),
        },
        {
          title: 'Asset',
          permissionProps: { items: [permissions.Asset.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <AccountBalanceWalletIcon />,
          path: locations.assetList(),
        },
        {
          title: 'Product Type',
          permissionProps: { items: [permissions.ProductType.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <ContactPageIcon />,
          path: locations.productTypeList(),
        },
        {
          title: 'User Category',
          permissionProps: { items: [permissions.UserCategory.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <AssignmentIndIcon />,
          path: locations.userCategoryList(),
        },
        {
          title: 'Portfolio',
          permissionProps: { items: [permissions.Portfolio.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <ContactPageIcon />,
          path: locations.portfolioList(),
          pathRegexp: new RegExp(`^${locations.portfolioList()}(/\\d+)?$`),
        },
        {
          title: 'Benchmark',
          permissionProps: { items: [permissions.Benchmark.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <ContactPageIcon />,
          path: locations.benchmarkList(),
          pathRegexp: new RegExp(`^${locations.benchmarkList()}(/\\d+)?$`),
        },
        {
          title: 'Subscribed',
          permissionProps: { items: [permissions.SubscribedPortfolio.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <ContactPageIcon />,
          path: locations.subscribedPortfolioList(),
          pathRegexp: new RegExp(`^${locations.subscribedPortfolioList()}(/\\d+)?$`),
        },
      ],
    },
    {
      title: 'Order MGM',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <TopicIcon />,
      permissionProps: { items: permissions.ReadOrderManagement, checkType: 'some' },
      children: [
        {
          title: 'Requests',
          permissionProps: { items: [permissions.UserPortfolioRequest.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <ViewListIcon />,
          path: locations.userPortfolioRequestList(),
          pathRegexp: new RegExp(`^${locations.userPortfolioRequestList()}(/\\d+)?$`),
        },
        {
          title: 'Orders',
          permissionProps: { items: [permissions.PortfolioOrder.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <ListAltIcon />,
          path: locations.portfolioOrderList(),
          pathRegexp: new RegExp(`^${locations.portfolioOrderList()}(/[a-z0-9-]+)?$`),
        },
        {
          title: 'Executions',
          permissionProps: { items: [permissions.OrderExecution.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <ReceiptIcon />,
          path: locations.orderExecutionList(),
          pathRegexp: new RegExp(`^${locations.orderExecutionList()}(/[a-z0-9-]+)?$`),
        },
      ],
    },
    {
      title: 'Asset Classes',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <FolderZipIcon />,
      permissionProps: { items: permissions.ReadFundManagement, checkType: 'some' },
      children: [
        {
          title: 'Index Funds',
          permissionProps: { items: [permissions.IndexFund.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <TrendingUpIcon />,
          path: locations.indexFundList(),
          pathRegexp: new RegExp(`^${locations.indexFundList()}(/[a-z0-9-]+)?$`),
        },
        {
          title: 'Funds Navs',
          permissionProps: { items: [permissions.IndexFund.list, permissions.IndexFund.navBulkUpdate] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <PriceChangeIcon />,
          path: locations.indexFundNavList(),
          pathRegexp: new RegExp(`^${locations.indexFundNavList()}(/[a-z0-9-]+)?$`),
        },
        {
          title: 'Geo. Focus',
          permissionProps: { items: [permissions.FundGeographicalFocus.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <AccountBalanceWalletIcon />,
          path: locations.fundGeographicalFocus(),
        },
        {
          title: 'Manager',
          permissionProps: { items: [permissions.FundManager.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <AssignmentIndIcon />,
          path: locations.fundManager(),
        },
        {
          title: 'Companies',
          permissionProps: { items: [permissions.HoldingCompany.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <BusinessCenterIcon />,
          path: locations.holdingCompany(),
        },
        {
          title: 'Asset Class',
          permissionProps: { items: [permissions.FundAssetClass.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <ContactPageIcon />,
          path: locations.fundAssetClass(),
        },
        {
          title: 'Valuation Day',
          permissionProps: { items: [permissions.FundValuationDay.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <ContactPageIcon />,
          path: locations.fundValuationDays(),
        },
        {
          title: 'Valuation Frequency',
          permissionProps: { items: [permissions.FundValuationFrequency.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <ViewListIcon />,
          path: locations.fundValuationFrequency(),
        },
      ],
    },
    {
      title: 'Fee MGM',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <FolderSpecialIcon />,
      // permissionProps: { items: permissions.ReadFeeManagement, checkType: 'some' },
      children: [
        {
          title: 'Fee Configs',
          // permissionProps: { items: [permissions.Portfolio.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <TuneIcon />,
          path: locations.feeConfigList(),
          pathRegexp: new RegExp(`^${locations.feeConfigList()}(/\\d+)?$`),
        },
        {
          title: 'Deductions',
          // permissionProps: { items: [permissions.UserFeeDeduction.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <ViewListIcon />,
          path: locations.userFeeDeductionList(),
          pathRegexp: new RegExp(`^${locations.userFeeDeductionList()}(/\\d+)?$`),
        },
        {
          title: 'Batches',
          // permissionProps: { items: [permissions.FeeBatch.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <ReceiptLongIcon />,
          path: locations.feeBatchList(),
          pathRegexp: new RegExp(`^${locations.feeBatchList()}(/[a-z0-9-]+)?$`),
        },
        {
          title: 'Executions',
          // permissionProps: { items: [permissions.BatchExecution.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <ReceiptIcon />,
          path: locations.batchExecutionList(),
          pathRegexp: new RegExp(`^${locations.batchExecutionList()}(/[a-z0-9-]+)?$`),
        },
        {
          title: 'Alpaca Fees',
          permissionProps: { items: [permissions.AlpacaFee.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <PriceChangeIcon />,
          path: locations.alpacaFeeList(),
        },
        {
          title: 'Alpaca Fee Report',
          permissionProps: { items: [permissions.AlpacaFee.report] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <SummarizeIcon />,
          path: locations.alpacaFeeReport(),
        },
      ],
    },
    {
      title: 'Permission',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <PolicyIcon />,
      permissionProps: { items: permissions.ReadPermissionManagement, checkType: 'some' },
      children: [
        {
          title: 'Roles',
          permissionProps: { items: [permissions.Role.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <PolicyIcon />,
          path: locations.roleList(),
        },
        {
          title: 'Resources',
          permissionProps: { items: [permissions.Resource.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <CategoryIcon />,
          path: locations.resourceList(),
        },
        {
          title: 'Actions',
          permissionProps: { items: [permissions.Action.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <CallToActionIcon />,
          path: locations.actionList(),
        },
        {
          title: 'Permissions',
          permissionProps: { items: [permissions.RolePermission.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <AdminPanelSettingsIcon />,
          path: locations.rolePermissionList(),
        },
        {
          title: 'Permissions2',
          permissionProps: { items: [permissions.RolePermission.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <AdminPanelSettingsIcon />,
          path: locations.rolePermissionList2(),
        },
      ],
    },
    {
      title: 'Payment',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <PaymentsIcon />,
      permissionProps: {
        items: [permissions.PaymentPermission.paymentStatement, permissions.PaymentPermission.paymentApiLogs],
        checkType: 'some',
      },
      path: locations.payment(),
    },
    {
      title: 'Reports',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <SummarizeIcon />,
      // No permission on the group: User details and Fee calculations are open to every logged-in admin.
      pathnameOpensParent: new RegExp(`^${locations.report()}(/|$)`),
      children: [
        {
          title: 'Reports',
          permissionProps: { items: [permissions.ReportPermission.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <SummarizeIcon />,
          path: locations.reportHub(),
          pathRegexp: new RegExp(`^${locations.reportHub()}$`),
        },
        {
          title: 'Cash transactions',
          permissionProps: { items: [permissions.ReportPermission.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <SummarizeIcon />,
          path: locations.reportCashTransactions(),
          pathRegexp: new RegExp(`^${locations.reportCashTransactions()}$`),
        },
        {
          title: 'Users',
          permissionProps: { items: [permissions.ReportPermission.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <SummarizeIcon />,
          path: locations.reportUsers(),
          pathRegexp: new RegExp(`^${locations.reportUsers()}$`),
        },
        {
          title: 'Orders',
          permissionProps: { items: [permissions.ReportPermission.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <SummarizeIcon />,
          path: locations.reportOrders(),
          pathRegexp: new RegExp(`^${locations.reportOrders()}$`),
        },
        {
          title: 'Portfolio details',
          permissionProps: { items: [permissions.ReportPermission.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <SummarizeIcon />,
          path: locations.reportPortfolioDetails(),
          pathRegexp: new RegExp(`^${locations.reportPortfolioDetails()}$`),
        },
        {
          title: 'Portfolio totals',
          permissionProps: { items: [permissions.ReportPermission.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <SummarizeIcon />,
          path: locations.reportPortfolioTotals(),
          pathRegexp: new RegExp(`^${locations.reportPortfolioTotals()}$`),
        },
        {
          title: 'CMA Users',
          permissionProps: { items: [permissions.ReportPermission.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <SummarizeIcon />,
          path: locations.reportCmaUsers(),
          pathRegexp: new RegExp(`^${locations.reportCmaUsers()}$`),
        },
        {
          title: 'AUM',
          permissionProps: { items: [permissions.ReportPermission.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <SummarizeIcon />,
          path: locations.reportAum(),
          pathRegexp: new RegExp(`^${locations.reportAum()}$`),
        },
        {
          title: 'Accumulated AUM',
          permissionProps: { items: [permissions.ReportPermission.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <SummarizeIcon />,
          path: locations.reportAccumulatedAum(),
          pathRegexp: new RegExp(`^${locations.reportAccumulatedAum()}$`),
        },
        {
          title: 'User details',
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <SummarizeIcon />,
          path: locations.reportUserDetails(),
          pathRegexp: new RegExp(`^${locations.reportUserDetails()}$`),
        },
        {
          title: 'Fee calculations',
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <SummarizeIcon />,
          path: locations.reportFeeCalculations(),
          pathRegexp: new RegExp(`^${locations.reportFeeCalculations()}$`),
        },
        {
          title: 'Finance users',
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <SummarizeIcon />,
          path: locations.reportFinanceUsers(),
          pathRegexp: new RegExp(`^${locations.reportFinanceUsers()}$`),
        },
        {
          title: 'Portfolio composition',
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <SummarizeIcon />,
          path: locations.reportPortfolioComposition(),
          pathRegexp: new RegExp(`^${locations.reportPortfolioComposition()}$`),
        },
        {
          title: 'Portfolio snapshot',
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <SummarizeIcon />,
          path: locations.reportPortfolioSnapshot(),
          pathRegexp: new RegExp(`^${locations.reportPortfolioSnapshot()}$`),
        },
        {
          title: 'Portfolio orders data',
          permissionProps: { items: [permissions.ReportPermission.list] },
          // eslint-disable-next-line react/no-unstable-nested-components
          IconComponent: () => <SummarizeIcon />,
          path: locations.reportPortfolioOrdersData(),
          pathRegexp: new RegExp(`^${locations.reportPortfolioOrdersData()}$`),
        },
      ],
    },
    {
      title: 'Promo Codes',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <DiscountIcon />,
      // permissionProps: { items: [permissions.ReportPermission.list], checkType: 'some' },
      path: locations.promoCodes(),
    },
    {
      title: 'Analytics',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <AnalyticsIcon />,
      // TODO: add analytics api to admin-serivce to use permission functionality
      // permissionProps: { items: [permissions.AnalyticsPermission.list], checkType: 'some' },
      path: locations.analytics(),
    },
    {
      title: 'Settings',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <SettingsIcon />,
      permissionProps: { items: permissions.Settings, checkType: 'some' },
      path: locations.settings(),
    },
    {
      title: 'Push Notifications',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <NotificationsIcon />,
      permissionProps: { items: [permissions.NotificationTemplate.list], checkType: 'some' },
      path: locations.notificationTemplateList(),
    },
    {
      title: 'Email Notifications',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <MarkEmailReadIcon />,
      permissionProps: { items: [permissions.NotificationTemplate.list], checkType: 'some' },
      path: locations.emailTemplateList(),
    },
    {
      title: 'IBAN Verification',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <VerifiedIcon />,
      path: locations.ibanVerification(),
    },
    {
      title: 'Banks',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <AccountBalanceIcon />,
      permissionProps: { items: [permissions.BankLookup.list] },
      path: locations.bankLookupList(),
    },
  ],
  [
    {
      title: 'Logout',
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: () => <LogoutIcon />,
      onClick: () => handleLogout(),
    },
  ],
];
